import React, { Component, Fragment } from 'react';
import TrainingPhaseFormCard from './TrainingPhaseFormCard';

class TrainingPhaseEdit extends Component {
  constructor(props) {
    super(props);
    console.log('this.props.phase', this.props.phase)
    this.state = {
      initialValues: {
        header: this.props.phase.header,
        forms: this.props.phase.forms,
        type: this.props.phase.type,
        weeks: this.props.phase.weeks,
        hours: this.props.phase.hours? parseInt(this.props.phase.hours): this.props.phase.hours,
      },
    };
  }

  updatePhase(formData) {
    this.props.onUpdate(formData);
  }

  render() {
    return (
      <Fragment>
        <TrainingPhaseFormCard
          initialValues={this.state.initialValues}
          onClose={() => this.props.onClose()}
          onSave={formData => this.updatePhase(formData)}
        />
      </Fragment>
    );
  }
}

export default TrainingPhaseEdit;
